import React, { useEffect } from "react"
import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    useDisclosure,
    Button,
  } from '@chakra-ui/react'
// import { Button } from "bootstrap"
import {Link as MyLink} from 'react-router-dom'
function Final() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = React.useRef()
    useEffect(() => { onOpen() }, []);
   
    return (
      <>
        
  
        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='xl' fontWeight='bold'>
               Thank you for your donation
              </AlertDialogHeader>
             
  
              <AlertDialogFooter>
                <Button backgroundColor={'#01BFBD'} color='white' onClick={onClose} ml={3}>
                  <MyLink to="/">Back to home</MyLink>
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </>
    )
}
export default Final;